import { z } from 'zod';
/**
 * Identificador de correlación (`X-Correlation-Id`) y `traceId` de Problem Details:
 * de 8 a 64 caracteres alfanuméricos, guion, guion bajo o punto, empezando por alfanumérico.
 * La API sustituye cualquier valor entrante que no cumpla este formato (docs/migration/10 §8).
 */
export const CorrelationIdSchema = z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._-]{7,63}$/);
//# sourceMappingURL=correlation.js.map